import { Scissors } from "lucide-react";

const ITEMS = ["CORTE", "BARBA", "ESTILO", "WALK-INS WELCOME", "BLACKBEARD BARBERÍA"];

export const Marquee = () => (
  <div className="relative border-y border-gold/15 bg-panel py-4 overflow-hidden" data-testid="brand-marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
          {ITEMS.map((it, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-lg sm:text-xl tracking-[0.25em] text-bone/80 px-6 whitespace-nowrap">
                {it}
              </span>
              <Scissors size={14} className="text-gold shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
